import React, { PureComponent as Component } from 'react';
import { CardBody, Collapse } from 'reactstrap';
import propTypes from 'prop-types';

import SearchForm from './SearchForm';
import SortForm from './SortForm';
import FilterForm from './FilterForm';

class Filters extends Component {
  constructor(props) {
    super(props)
    this.state = {
      keyword: props.keyword,
      category: props.category,
      language_code: props.language_code,
      active: props.active,
    }
    this._handleApplyFilterButtonClick = this._handleApplyFilterButtonClick.bind(this);
    this._handleOnChangeInput = this._handleOnChangeInput.bind(this);
    this._handleCategoryChangeInput = this._handleCategoryChangeInput.bind(this);
  }

  _handleCategoryChangeInput(val) {
    const lastState = {...this.state};
    let category = val
    lastState['category'] = category
    this.setState({...lastState});
  }

  _handleOnChangeInput(e){
    const lastState = {...this.state};
    lastState[e.target.name] = e.target.value;
    this.setState({...lastState});
  }

  _handleApplyFilterButtonClick(e){
    e.preventDefault();
    this._handleSubmitFilter();
  }

  _handleSubmitFilter(){
    const {
      keyword,
      category,
      language_code,
      active
    } = this.state;
    const { per_page, sort_by } = this.props;
    this.props.onApplyFilter({
      keyword,
      category: category ? category.id : null,
      language_code,
      active,
      per_page,
      sort_by
    });
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.isReset && this.props.isReset!==nextProps.isReset){
      const {
        keyword,
        category,
        language_code,
        active
      } = nextProps;
      this.setState({
        keyword,
        category,
        language_code,
        active
      })
    }
  }

  render(){
    return(
      <Collapse isOpen={this.props.isOpen}>
        <CardBody className="filter-container__card-body">
          <SearchForm
            keyword = {this.state.keyword}
            onInputChange = {this._handleOnChangeInput}
            onSubmit = {this._handleApplyFilterButtonClick}
          />
          <FilterForm
            category={this.state.category}
            language_code={this.state.language_code}
            active={this.state.active}
            onInputChange={this._handleOnChangeInput}
            onCategoryInputChange = {this._handleCategoryChangeInput}
            isCheckedCategory = {this._isCheckedCategory}
            onSubmit={this._handleApplyFilterButtonClick}
          />
          <hr/>
          <SortForm
            per_page={this.props.per_page}
            sort_by={this.props.sort_by}
            onInputChange={this.props.onHandleChangeAndSubmit}
          />
        </CardBody>
      </Collapse>
    )
  }
}

export default Filters

Filters.propTypes= {
  keyword: propTypes.string,
  category: propTypes.oneOfType([propTypes.number, propTypes.object]),
  language_code: propTypes.string,
  active: propTypes.string,
  per_page: propTypes.oneOfType([propTypes.number, propTypes.string]),
  sort_by: propTypes.string,
  isOpen: propTypes.bool.isRequired,
  onHandleChangeAndSubmit: propTypes.func,
  onApplyFilter: propTypes.func
}

Filters.defaultProps= {
  keyword: '',
  category: '',
  language_code: '',
  active: '',
  per_page: 15,
  sort_by: ''
}
